import AISearch from "../modules/ai-search";

document.addEventListener("DOMContentLoaded", () => {
  const isQuickSearch =
    document.querySelectorAll("#supercontrol-properties-list").length == 0;
  if (isQuickSearch) {
    AISearch.simpleSetup();
    return;
  }
  AISearch.setup();
});
